import { IMAGES, COMMODITIES } from "@/lib/constants";

export const localizeProducts = (lang) =>
  PRODUCTS.map((p) => (lang === "fr" && p.fr ? { ...p, ...p.fr } : p));

export const PRODUCTS = [
  {
    slug: "copper-cathode",
    name: "Copper Cathode",
    short: "Grade A · 99.99%",
    tagline: "LME-standard electrolytic copper, refined at source.",
    image: IMAGES.cathodesWarehouse,
    commodity: COMMODITIES[0],
    description:
      "Grade A copper cathodes with purity from 99.97% to 99.99%, conforming to LME standards (Non-LME registered options available). Supplied as rectangular sheets, bundled and container-ready.",
    specs: [
      { label: "Grade", value: "Grade A (LME standard)" },
      { label: "Purity", value: "99.97% – 99.99% Cu" },
      { label: "Form", value: "Rectangular electrolytic sheets" },
      { label: "Sheet Weight", value: "≈ 50 – 125 kg per sheet" },
      { label: "Packaging", value: "Steel-strapped bundles, containerized" },
      { label: "Origin", value: "Katanga Copperbelt, DRC" },
    ],
    usage: "Electrical wiring, industrial manufacturing, and national power grids.",
    fr: {
      name: "Cathode de Cuivre",
      short: "Grade A · 99,99%",
      tagline: "Cuivre électrolytique de norme LME, raffiné à la source.",
      description:
        "Cathodes de cuivre Grade A avec une pureté de 99,97 % à 99,99 %, conformes aux normes LME (options non enregistrées LME disponibles). Fournies en feuilles rectangulaires, en bottes prêtes pour conteneur.",
      specs: [
        { label: "Grade", value: "Grade A (norme LME)" },
        { label: "Pureté", value: "99,97 % – 99,99 % Cu" },
        { label: "Forme", value: "Feuilles électrolytiques rectangulaires" },
        { label: "Poids par Feuille", value: "≈ 50 – 125 kg par feuille" },
        { label: "Conditionnement", value: "Bottes cerclées d'acier, conteneurisées" },
        { label: "Origine", value: "Ceinture de Cuivre du Katanga, RDC" },
      ],
      usage: "Câblage électrique, fabrication industrielle et réseaux électriques nationaux.",
    },
  },
  {
    slug: "copper-concentrate-ore",
    name: "Copper Concentrate & Ore",
    short: "Chalcopyrite · Malachite",
    tagline: "High-grade feed direct from DRC concessions.",
    image: IMAGES.copperOre,
    commodity: COMMODITIES[1],
    description:
      "High-grade chalcopyrite or malachite concentrates raw from DRC mining concessions. Custom concentration percentages optimized for global smelters.",
    specs: [
      { label: "Mineralogy", value: "Chalcopyrite / Malachite" },
      { label: "Cu Content", value: "Custom per smelter spec (20% – 35%+)" },
      { label: "Form", value: "Crushed ore / concentrated fines" },
      { label: "Moisture", value: "Controlled per shipment contract" },
      { label: "Packaging", value: "Bulk / 1MT jumbo bags" },
      { label: "Origin", value: "DRC mining concessions" },
    ],
    usage: "Feedstock for global copper smelters and refineries.",
    fr: {
      name: "Concentré & Minerai de Cuivre",
      short: "Chalcopyrite · Malachite",
      tagline: "Minerai haute teneur directement des concessions de la RDC.",
      description:
        "Concentrés de chalcopyrite ou malachite haute teneur, bruts, issus des concessions minières de la RDC. Pourcentages de concentration personnalisés, optimisés pour les fonderies mondiales.",
      specs: [
        { label: "Minéralogie", value: "Chalcopyrite / Malachite" },
        { label: "Teneur en Cu", value: "Personnalisée selon la fonderie (20 % – 35 %+)" },
        { label: "Forme", value: "Minerai concassé / fines concentrées" },
        { label: "Humidité", value: "Contrôlée selon le contrat d'expédition" },
        { label: "Conditionnement", value: "Vrac / big bags de 1 MT" },
        { label: "Origine", value: "Concessions minières de la RDC" },
      ],
      usage: "Matière première pour les fonderies et raffineries de cuivre mondiales.",
    },
  },
  {
    slug: "precious-gold",
    name: "Precious Gold Collective",
    short: "Dore · Alluvial",
    tagline: "Responsibly sourced, fully documented gold.",
    image: IMAGES.goldDore,
    commodity: COMMODITIES[2],
    description:
      "All types of gold, including responsibly sourced dore bars and unrefined alluvial gold, fully documented with legal export certificates.",
    specs: [
      { label: "Forms", value: "Dore bars & alluvial gold" },
      { label: "Purity", value: "Assay-verified per lot" },
      { label: "Documentation", value: "Full legal export certificates" },
      { label: "Sourcing", value: "Responsibly mined, traceable lots" },
      { label: "Security", value: "Insured secure logistics chain" },
      { label: "Origin", value: "Certified DRC sources" },
    ],
    usage: "Refineries, bullion houses, and sovereign reserve programs.",
    fr: {
      name: "Collection d'Or Précieux",
      short: "Doré · Alluvial",
      tagline: "Or d'origine responsable, entièrement documenté.",
      description:
        "Tous types d'or, y compris lingots doré d'origine responsable et or alluvial non raffiné, entièrement documentés avec certificats d'exportation légaux.",
      specs: [
        { label: "Formes", value: "Lingots doré & or alluvial" },
        { label: "Pureté", value: "Vérifiée par essai pour chaque lot" },
        { label: "Documentation", value: "Certificats d'exportation légaux complets" },
        { label: "Approvisionnement", value: "Extraction responsable, lots traçables" },
        { label: "Sécurité", value: "Chaîne logistique sécurisée et assurée" },
        { label: "Origine", value: "Sources certifiées de la RDC" },
      ],
      usage: "Raffineries, négociants en métaux précieux et programmes de réserves souveraines.",
    },
  },
  {
    slug: "lithium-ore",
    name: "Lithium Ore",
    short: "Spodumene · Lepidolite",
    tagline: "Feeding the global green energy transition.",
    image: IMAGES.lithium,
    commodity: COMMODITIES[3],
    description:
      "High-purity spodumene/lepidolite ores mined to support global green energy storage and EV battery supply chains.",
    specs: [
      { label: "Mineralogy", value: "Spodumene / Lepidolite" },
      { label: "Li₂O Content", value: "High-purity, assay on request" },
      { label: "Form", value: "Run-of-mine ore / crushed" },
      { label: "Target Market", value: "EV battery & storage supply chains" },
      { label: "Packaging", value: "Bulk vessel / containerized" },
      { label: "Origin", value: "DRC lithium belts" },
    ],
    usage: "Battery-grade lithium conversion for EV and grid storage.",
    fr: {
      name: "Minerai de Lithium",
      short: "Spodumène · Lépidolite",
      tagline: "Au service de la transition énergétique mondiale.",
      description:
        "Minerais de spodumène/lépidolite de haute pureté extraits pour soutenir le stockage d'énergie verte mondial et les chaînes d'approvisionnement en batteries pour véhicules électriques.",
      specs: [
        { label: "Minéralogie", value: "Spodumène / Lépidolite" },
        { label: "Teneur en Li₂O", value: "Haute pureté, essai sur demande" },
        { label: "Forme", value: "Minerai tout-venant / concassé" },
        { label: "Marché Cible", value: "Chaînes de batteries VE & stockage" },
        { label: "Conditionnement", value: "Navire vrac / conteneurisé" },
        { label: "Origine", value: "Ceintures de lithium de la RDC" },
      ],
      usage: "Conversion de lithium qualité batterie pour VE et stockage réseau.",
    },
  },
  {
    slug: "sulphur-granulars",
    name: "Sulphur Granulars",
    short: "Industrial Grade",
    tagline: "Bright yellow sulphur for metallurgy & fertilizer.",
    image: IMAGES.sulphur,
    commodity: COMMODITIES[4],
    description:
      "Industrial-grade, high-purity bright yellow sulphur granules utilized heavily in metallurgical processing and fertilizer production.",
    specs: [
      { label: "Purity", value: "99.5%+ industrial grade" },
      { label: "Form", value: "Bright yellow granules / pastilles" },
      { label: "Color", value: "Bright yellow" },
      { label: "Packaging", value: "50kg bags / 1MT jumbo bags / bulk" },
      { label: "Applications", value: "Metallurgical processing, fertilizer" },
      { label: "Supply", value: "Monthly contract volumes available" },
    ],
    usage: "Sulphuric acid plants, leaching circuits, and fertilizer production.",
    fr: {
      name: "Granulés de Soufre",
      short: "Qualité Industrielle",
      tagline: "Soufre jaune vif pour la métallurgie et les engrais.",
      description:
        "Granulés de soufre jaune vif de haute pureté, qualité industrielle, largement utilisés dans le traitement métallurgique et la production d'engrais.",
      specs: [
        { label: "Pureté", value: "99,5 %+ qualité industrielle" },
        { label: "Forme", value: "Granulés / pastilles jaune vif" },
        { label: "Couleur", value: "Jaune vif" },
        { label: "Conditionnement", value: "Sacs de 50 kg / big bags 1 MT / vrac" },
        { label: "Applications", value: "Traitement métallurgique, engrais" },
        { label: "Approvisionnement", value: "Volumes contractuels mensuels disponibles" },
      ],
      usage: "Usines d'acide sulfurique, circuits de lixiviation et production d'engrais.",
    },
  },
];
